import React from 'react';

import {DeletedQueriesSidebar} from './deleted-queries-sidebar';
import {FavoriteQueriesSidebar} from './favorite-queries-sidebar';
import {QueryDraftsSidebar} from './query-drafts-sidebar';
import {QueryHistorySidebar} from './query-history-sidebar';
import {RunningQueriesSidebar} from './running-queries-sidebar';
import {SharedQueriesSidebar} from './shared-queries-sidebar';
import {LayoutContextValue} from '../../../components/layout/page-layout/use-page-layout';
import {useSidebarTabs} from '../../../hooks/use-sidebar-tabs';

interface Props {
    tabSettings: ReturnType<typeof useSidebarTabs>;
    layoutSettings: LayoutContextValue;
    queryId?: number;
}

export const QueriesSidebar = (props: Props) => {
    switch (props.tabSettings.activityBarTab) {
        default:
        case 'drafts':
            return (
                <QueryDraftsSidebar
                    closeSidebar={props.layoutSettings.closeSidebar}
                    queryId={props.queryId}
                />
            );
        case 'running':
            return (
                <RunningQueriesSidebar
                    closeSidebar={props.layoutSettings.closeSidebar}
                    queryId={props.queryId}
                />
            );
        case 'favorites':
            return (
                <FavoriteQueriesSidebar
                    closeSidebar={props.layoutSettings.closeSidebar}
                    queryId={props.queryId}
                />
            );
        case 'recent':
            return (
                <QueryHistorySidebar
                    closeSidebar={props.layoutSettings.closeSidebar}
                    queryId={props.queryId}
                />
            );
        case 'shared':
            return (
                <SharedQueriesSidebar
                    closeSidebar={props.layoutSettings.closeSidebar}
                    queryId={props.queryId}
                />
            );
        case 'bin':
            return (
                <DeletedQueriesSidebar
                    closeSidebar={props.layoutSettings.closeSidebar}
                    queryId={props.queryId}
                />
            );
    }
};
